export default function (val) {
  if (val.Availability == 1) return 'Есть'
  if (val.Availability == 2) return 'Запрос'
  if (val.Availability == 4) return 'Нет'
}
